import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';

var _createNamespace = createNamespace('sidebar-item'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

import {ChildrenMixin} from '../../common/utils/relation';
export default {
    mixins: [ChildrenMixin('Sidebar')],
    name: getComponentName('SidebarItem'),
    props: {
        title: String,
        disabled: Boolean
    },
    computed: {
        select: function select() {
            var _a;

            return this.index === +((_a = this.parent) === null || _a === void 0 ? void 0 : _a.activeKey);
        }
    },
    methods: {
        handleOnClick: function handleOnClick() {
            if (this.disabled) {
                return;
            }

            this.$emit('click', this.index);
            this.parent.$emit('input', this.index);
            this.parent.$emit('change', this.index);
        }
    },
    render: function render() {
        var h = arguments[0];
        return h(
            'a',
            {
                class: b({
                    select: this.select,
                    disabled: this.disabled
                }),
                on: {
                    click: this.handleOnClick
                }
            },
            [
                h(
                    'span',
                    {
                        class: b('text')
                    },
                    [this.title]
                )
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
